import { Component, Vue } from 'vue-property-decorator'
import { menuBtn } from '@/utils/menu_level2_button'
import { formatDate } from '@/utils/timeFilter'
import {getMessageRemindById, getMessageReviewById, setMessageReviewUserByMessageReviewId} from '@/api/message'
import { setFinanceOrderStatus, getProjectList } from '@/api/financial-center'
// import { get } from '@/api/financial-center'

@Component({})
export default class OrderInfo extends Vue {
    priceSum: number = undefined //订单金额合计
    infoData: any = {}
    reviewId: number;
    logShow = true
    withdrawalDialogShow = false // 撤回审批弹框
    reviewIdea = '' // 审批意见
    reviewDialogShow = false // 审批意见弹框
    status: string
    approvalStatus: number = null
    type = ''
    editFileList: { file: string; cnFile: string; isRequired: string }[] = []
    editFiles = {
        projectAllId: null,
        souCoursePrice: null,
        discountPrice: null,
        price: null,
        haveIPQ: null,
        remark: null,
        priceOrRatio: null,
        isCredit: null,
        dissertationType: null,
    }

    projectDialogShow = false
    projectDialogTableLoading = false
    dialogProjectInputValue = ''
    dialogProjectPage = 1
    dialogProjectLimit = 20
    projectDialogTableData = []
    projectDialogCheckedTable = {
        flag: false,
        projectAllId: NaN,
        souCourseIndex: "",
        souCourseName: "",
        souCoursePrice: "",
        souCourseSchoolBegin: "",
        souCourseType: "",
        status: "",
        surplusQuota: NaN
    }
    dialogProjectTotal = 0
    customerInfo = {
        customerId: undefined,
        customerName: '',
        customerSource: '',
        customerSourceType: '',
        customerType: '',
        marketCooperationId: undefined
    }
    isRequired = false
    editFileRequired = false
    // newOrderData: any = []
    types=""
    loading = false
    activities = []

    created() {
        //  获取地址栏里的参数
        const url = window.location.href
        const p = url.split('?')[1]
        const params = new URLSearchParams(p)
        const recordId = params.get('id')
        this.types = this.$route.query.types ? this.$route.query.types as string : ''
        this.getMsgData(recordId)

    }

    menuBtn = menuBtn
    formatDate = formatDate

    // 获取数据
    async getMsgData(id) {
        this.loading = true
        await getMessageRemindById({id: id}).then((data: any) => {
            this.infoData = data.result.messageRemindInfo
            this.priceSum = this.infoData.price  //订单金额合计
            this.editFileList = this.infoData.editFileList || []
            this.editFileList.forEach(item => {
                this.editFiles[item.file] = this.infoData[item.file]
            })
            if (this.editFileList && this.editFileList.length > 0) this.isRequired = this.type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填
            this.activities = this.infoData.messageReviewList
            this.loading = false
        }).catch(err => {
            this.loading = false
        })
    }
    async getData() {
        const data: any = await getMessageReviewById(this.reviewId,this.types)
        this.infoData = data.result
        this.priceSum = this.infoData.price  //订单金额合计
        this.editFileList = this.infoData.editFileList || []
        this.editFileList.forEach(item => {
            this.editFiles[item.file] = this.infoData[item.file]
        })
        if(this.editFileList && this.editFileList.length > 0) this.isRequired = this.type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填
    }

    // 验证当前字段是否可以编辑
    editFileShow(key: string) {
        if (this.status !== '0' || this.type !== '0') return false
        return this.editFileList.some(item => item.file === key)
    }

    projectInputFocus() {
        this.projectDialogShow = true
        this.getProjectList();
        (this.$refs.projectInput as HTMLFormElement).blur()
    }

    async getProjectList() {
        this.projectDialogTableLoading = true
        const data: any = await getProjectList({
            marketCooperationId: this.infoData.marketCooperationId,
            name: this.dialogProjectInputValue,
            page: this.dialogProjectPage,
            limit: this.dialogProjectLimit
        })
        this.projectDialogTableData = data.projectList
        this.dialogProjectTotal = data.allNum
        this.projectDialogTableLoading = false
    }

    projectPageChange(page: number) {
        this.dialogProjectPage = page
        this.getProjectList()
    }

    clickProjectDialogConfirmButton() {
        this.editFiles.projectAllId = this.projectDialogCheckedTable.projectAllId
        this.infoData.souCourseName = this.projectDialogCheckedTable.souCourseName
        this.editFiles.souCoursePrice = this.projectDialogCheckedTable.souCoursePrice
        this.editFiles.price = this.editFiles.souCoursePrice - this.editFiles.discountPrice
        this.projectDialogShow = false
    }

    dialogProjectTableCheckedChange(selection) {
        if (selection.length > 0) {
            this.projectDialogCheckedTable = JSON.parse(JSON.stringify(selection[0]))
            const dom = this.$refs.dialogProjectTable as HTMLFormElement
            if (selection.length > 1) {
                dom.clearSelection();
                dom.toggleRowSelection(selection.pop());
            }
            // if (this.projectDialogCheckedTable) {
            //     this.formModel.project = this.projectDialogCheckedTable.souCourseName
            // }
        } else {
            for (const key in this.projectDialogCheckedTable) {
                this.projectDialogCheckedTable[key] = null
            }
            // this.formModel.project = ''
        }
    }

    discountPriceChange() {
        if (Number(this.editFiles.discountPrice) > Number(this.infoData.souCoursePrice)) {
            this.$message.error('优惠金额不能大于项目终端售价')
            return
        }
        this.priceSum = Number(this.infoData.souCoursePrice) - Number(this.editFiles.discountPrice) //订单金额合计
        // this.editFiles.price = this.editFiles.souCoursePrice - this.editFiles.discountPrice //订单金额合计
    }

    dialogProjectRowClick(row) {
        if (!row.flag) return
        (this.$refs.dialogProjectTable as HTMLFormElement).toggleRowSelection(row)
    }

    selectable(row) {
        return row.flag
    }

    // 撤回审批
    async cancelApproval() {
        await setFinanceOrderStatus({ id: this.infoData.id, action: '1' })
        this.$message.success('撤销审批成功')
        setTimeout(() => {
            window.close()
        }, 1500);
        this.withdrawalDialogShow = false
    }

    // 通过、驳回审批
    clickExamineApproveButton(status: number) {
        this.approvalStatus = status
        this.reviewDialogShow = true
    }

    // 关闭审批意见弹框
    closeReviewDialog() {
        this.reviewIdea = ''
        this.reviewDialogShow = false
    }

    // 审批意见确认
    confirmReviewDialog() {
        this.editFiles.price = this.priceSum
        const newObj = this.editFiles
        for (const key in newObj) {
            if (!this.editFileList.some(item => item.file === key)) {
                delete newObj[key]
            }
        }
        if(this.isRequired) {
            for(const key in newObj) {
                if(!newObj[key] || newObj[key].length === 0) {
                    this.editFileRequired = true
                    break;
                } else {
                    this.editFileRequired = false
                }
            }
        }
        if(this.editFileRequired) {
            this.$message.error('请将编辑的信息填写完整')
            return
        }
        const obj = {
            messageReviewId: this.reviewId,
            status: this.approvalStatus,
            opinion: this.reviewIdea,
            form: this.approvalStatus ? newObj : {},
        }
        setMessageReviewUserByMessageReviewId(obj).then(() => {
            this.$message.success(this.approvalStatus === 1 ? '审批通过' : '审批驳回')
            this.reviewIdea = ''
            this.reviewDialogShow = false
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch((err: Error) => {
            console.log(err)
        })
    }


    handleClickEgistrationForm() {
        this.downFile(this.infoData.egistrationForm,  this.infoData.customerName)
    }

    // 下载文件，自定义文件名称
    downFile(url, fileName) {
        const x = new XMLHttpRequest()
        x.open('GET', url, true)
        x.responseType = 'blob'
        x.onload = function() {
            const url = window.URL.createObjectURL(x.response)
            const a = document.createElement('a')
            a.href = url
            a.download = fileName
            a.click()
        }
        x.send()
    }
}
